import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://xakqoonbjidtznndpnaa.supabase.co'
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inhha3Fvb25iamlkdHpubmRwbmFhIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzA2MTY0MDgsImV4cCI6MjA4NjE5MjQwOH0.mc2QvvXhZCDXRmkP_AtHXGurVNl_IEsD0Up10Xu-LDA'

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Import the supabase client like this:
// For React:
// import { supabase } from "@/integrations/supabase/client";
// For React Native:
// import { supabase } from "@/src/integrations/supabase/client";
